export enum ComparadoresEnum {
  EndesaLibreConPermanencia = 'EndesaLibreConPermanenciaComparator20Td',
  EndesaLibreSinPermanencia = 'EndesaLibreSinPermanenciaComparator20Td',
  GanaEnergia = 'GanaEnergiaComparator20Td',
  IberdrolaMas10KwPlanEstable = 'IberdrolaMas10KwPlanEstableComparator20Td',
  IberdrolaMas10KwPlanEstableMasPackIberdrola = 'IberdrolaMas10KwPlanEstableMasPackIberdrolaComparator20Td',
  IberdrolaPlanEstable = 'IberdrolaPlanEstableComparator20Td',
  IberdrolaPlanEstableMasPackIberdrola = 'IberdrolaPlanEstableMasPackIberdrolaComparator20Td',
  NaturgyFijoLuz = 'NaturgyFijoLuzComparator20Td',
  NaturgyOneFijo = 'NaturgyOneFijoComparator20Td',
  NaturgyPagoPorUso = 'NaturgyPagoPorUsoComparator20Td',
  NaturgyPagoPorUsoServicio = 'NaturgyPagoPorUsoServicioComparator20Td',
  NaturgySupraFijo = 'NaturgySupraFijoComparator20Td',
  OndaEnergia = 'OndaEnergiaComparator20Td',
  RepsolAltoValor = 'RepsolAltoValorComparator20Td',
  RepsolMedioValor = 'RepsolMedioValorComparator20Td',
  TotalEnergies = 'TotalEnergiesComparator20Td',
}

export const ProveedorToEnumMap: Record<string, ComparadoresEnum> = {
  'ENDESA - LIBRE CON PERMANENCIA': ComparadoresEnum.EndesaLibreConPermanencia,
  'ENDESA - LIBRE SIN PERMANENCIA': ComparadoresEnum.EndesaLibreSinPermanencia,
  'GANA ENERGIA': ComparadoresEnum.GanaEnergia,
  'IBERDROLA - PLAN ESTABLE (+10KW)': ComparadoresEnum.IberdrolaMas10KwPlanEstable,
  'IBERDROLA - PLAN ESTABLE + PACK IBERDROLA (+10KW)': ComparadoresEnum.IberdrolaMas10KwPlanEstableMasPackIberdrola,
  'IBERDROLA - PLAN ESTABLE': ComparadoresEnum.IberdrolaPlanEstable,
  'IBERDROLA - PLAN ESTABLE + PACK IBERDROLA': ComparadoresEnum.IberdrolaPlanEstableMasPackIberdrola,
  'NATURGY - FIJO LUZ': ComparadoresEnum.NaturgyFijoLuz,
  'NATURGY - ONE FIJO': ComparadoresEnum.NaturgyOneFijo,
  'NATURGY - PAGO POR USO': ComparadoresEnum.NaturgyPagoPorUso,
  'NATURGY - PAGO POR USO + SERVICIO': ComparadoresEnum.NaturgyPagoPorUsoServicio,
  'NATURGY - SUPRA FIJO': ComparadoresEnum.NaturgySupraFijo,
  'ONDA ENERGIA': ComparadoresEnum.OndaEnergia,
  'REPSOL - ALTO VALOR': ComparadoresEnum.RepsolAltoValor,
  'REPSOL - MEDIO VALOR': ComparadoresEnum.RepsolMedioValor,
  TOTALENERGIES: ComparadoresEnum.TotalEnergies,
};
